import { ProductRenderer } from '../ProductRenderer';

export class Keyboard {
	constructor(private renderer: ProductRenderer) {
		this.renderer = renderer;
		this.onKeyDown = this.onKeyDown.bind(this);
	}

	init() {
		window.addEventListener('keydown', this.onKeyDown);
	}

	private onKeyDown(event: KeyboardEvent) {
		switch (event.key) {
			default:
				break;
		}
	}
}
